// extracted by mini-css-extract-plugin
module.exports = {"label":"Label-module__label___OsrXy","text":"Label-module__text___e8GvT","description":"Label-module__description___kbAZd"};